export default __webpack_public_path__ + "static/media/watch.00532770.svg";